import { useTranslation } from 'react-i18next';
import { AuditLogSection } from '@/components/admin/AuditLogPage/AuditLogSection';
import { Card } from '@/components/ui/card';

interface ActivityTabProps {
  tenantId: string;
}

export function ActivityTab({ tenantId }: ActivityTabProps) {
  const { t } = useTranslation('modules');

  return (
    <Card padding="md">
      <h2 className="text-sm font-bold text-zooindigo mb-1">{t('admin.activityTitle')}</h2>
      <p className="text-xs text-zoomuted mb-4">{t('admin.activitySubtitle')}</p>
      <AuditLogSection tenantId={tenantId} />
    </Card>
  );
}
